// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React, { PropsWithChildren } from 'https://esm.sh/react@18';

type LayoutInternalProps = {
  logo: string;
  appName: string;
  appUrl: string;
};
export function LayoutInternal({ children, logo, appUrl, appName }: PropsWithChildren<LayoutInternalProps>) {
  return (
    <html
      dir="ltr"
      lang="en"
      style={{
        height: '100%',
      }}
    >
      <head></head>
      <body
        style={{
          margin: 0,
          padding: '32px 0px',
          boxSizing: 'border-box',
          backgroundColor: '#f9fafb',
          color: '#242424',
        }}
      >
        <table
          align="center"
          width="100%"
          style={{
            fontFamily: 'Inter, sans-serif',
            boxSizing: 'inherit',
            backgroundColor: '#FFFFFF',
            maxWidth: '600px',
            minHeight: '48px',
            borderRadius: '12px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
          }}
          role="presentation"
          cellSpacing="0"
          cellPadding="0"
          border={0}
          bgcolor="#FFFFFF"
        >
          <tbody
            style={{
              boxSizing: 'inherit',
            }}
          >
            <tr
              style={{
                boxSizing: 'inherit',
                width: '100%',
              }}
            >
              <td
                style={{
                  boxSizing: 'inherit',
                }}
              >
                <table
                  align="center"
                  width="100%"
                  cellPadding="0"
                  border={0}
                  style={{
                    boxSizing: 'inherit',
                    tableLayout: 'fixed',
                    borderCollapse: 'collapse',
                  }}
                >
                  <tbody
                    style={{
                      boxSizing: 'inherit',
                      width: '100%',
                    }}
                  >
                    <tr
                      style={{
                        boxSizing: 'inherit',
                        width: '100%',
                      }}
                    >
                      <td
                        style={{
                          boxSizing: 'content-box',
                          verticalAlign: 'middle',
                          textAlign: 'center',
                          padding: '40px 40px 0px 40px',
                        }}
                        valign="middle"
                      >
                        <a href={appUrl} target="_blank">
                          <img
                            src={logo}
                            alt="logo"
                            style={{
                              maxWidth: '370px',
                              maxHeight: '40px',
                              margin: '0px auto',
                            }}
                          />
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <table
                  align="center"
                  width="100%"
                  cellPadding="0"
                  border={0}
                  style={{
                    boxSizing: 'inherit',
                    tableLayout: 'fixed',
                    borderCollapse: 'collapse',
                  }}
                >
                  <tbody
                    style={{
                      boxSizing: 'inherit',
                      width: '100%',
                    }}
                  >
                    <tr
                      style={{
                        boxSizing: 'inherit',
                        width: '100%',
                      }}
                    >
                      <td
                        style={{
                          padding: '40px',
                        }}
                      >
                        {children}
                      </td>
                    </tr>
                  </tbody>
                </table>

                <hr
                  style={{
                    boxSizing: 'inherit',
                    margin: '0px',
                    width: '100%',
                    border: 'none',
                    borderTop: '1px solid #eaeaea',
                    borderColor: 'rgb(233, 233, 233)',
                    borderTopWidth: '1px',
                  }}
                />

                <table
                  align="center"
                  width="100%"
                  cellPadding="0"
                  border={0}
                  style={{
                    boxSizing: 'inherit',
                    tableLayout: 'fixed',
                    borderCollapse: 'collapse',
                  }}
                >
                  <tbody
                    style={{
                      boxSizing: 'inherit',
                      width: '100%',
                    }}
                  >
                    <tr
                      style={{
                        boxSizing: 'inherit',
                        width: '100%',
                      }}
                    >
                      <td
                        style={{
                          color: '#474849',
                          fontSize: '12px',
                          fontWeight: 'normal',
                          padding: '24px 40px 24px 40px',
                          textAlign: 'center',
                          maxWidth: '100%',
                          boxSizing: 'border-box',
                        }}
                      >
                        <p
                          style={{
                            boxSizing: 'inherit',
                            marginTop: '0px',
                            marginBottom: '0px',
                          }}
                        >
                          {appName} © {new Date().getFullYear()}
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </body>
    </html>
  );
}

// Embedded logo as base64 data URI for reliable email client display
const LOGO_BASE64 = 'data:image/png;base64,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';

function Layout({ children }: PropsWithChildren) {
  return (
    <LayoutInternal
      appName={Deno.env.get('APP_NAME') ?? ''}
      appUrl={Deno.env.get('FRONTEND_APP_URL') ?? ''}
      logo={LOGO_BASE64}
    >
      {children}
    </LayoutInternal>
  );
}

export default Layout;
